import { Stack } from '@mantine/core';
import { FieldListItem } from './FieldListItem';
import type { Field, FieldState, FieldEvent, WorkAvailability } from '../../types';
import type { SeedingSymbol } from '../../constants';
import { colors } from '../../theme';

interface FieldListProps {
  fields: Field[];
  onFieldClick: (fieldId: string) => void;
  onFieldHover: (fieldId: string | null) => void;
  hoveredFieldId: string | null;
  /** 圃場ステートのマップ（fieldId -> FieldState） */
  statesMap?: Map<string, FieldState>;
  /** 圃場イベントのマップ（fieldId -> FieldEvent[]） */
  eventsMap?: Map<string, FieldEvent[]>;
  risksMap?: Map<
    string,
    Array<{
      date: Date;
      riskIcon: string;
      riskSymbol: SeedingSymbol | undefined;
      riskLevel: number;
    }>
  >;
  /** 圃場IDごとの作業可否データ */
  workAvailabilitiesMap?: Record<string, WorkAvailability[]>;
}

/**
 * 圃場リストコンポーネント
 * 圃場カードを縦に積み重ねて表示
 */
export function FieldList({
  fields,
  onFieldClick,
  onFieldHover,
  hoveredFieldId,
  statesMap = new Map(),
  eventsMap = new Map(),
  risksMap = new Map(),
  workAvailabilitiesMap = {},
}: FieldListProps) {
  if (fields.length === 0) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: colors.gray[600] }}>
        圃場データがありません
      </div>
    );
  }

  return (
    <Stack gap={0}>
      {fields.map((field) => (
        <FieldListItem
          key={field.id}
          field={field}
          onClick={() => onFieldClick(field.id)}
          onHover={onFieldHover}
          isHovered={hoveredFieldId === field.id}
          state={statesMap.get(field.id)}
          events={eventsMap.get(field.id)}
          riskData={risksMap.get(field.id)}
          workAvailabilities={workAvailabilitiesMap[field.id]}
        />
      ))}
    </Stack>
  );
}
